import { useEffect, useState } from "react";
import {
  getCompanyActivityTypes,
  getInstallationKeys,
  getRegulatoryPermissionKeys,
  getProducts,
  getEmailList,
  CatalogActivityTypes,
  CatalogInstallationKeys,
  RequestRegulatoryPermissionKeys,
  Products,
} from "../../api/generated";
import { useClient } from "../../hooks/useClient";

interface UseCatalogsResult {
  activityTypes: CatalogActivityTypes[];
  installationKeys: CatalogInstallationKeys[];
  regulatoryPermissionKeys: RequestRegulatoryPermissionKeys[];
  products: Products[];
  availableEmails: string[];
  isLoading: boolean;
}

export function useCatalogsDistributionPoint(): UseCatalogsResult {
  const [activityTypes, setActivityTypes] = useState<CatalogActivityTypes[]>([]);
  const [installationKeys, setInstallationKeys] = useState<CatalogInstallationKeys[]>([]);
  const [regulatoryPermissionKeys, setRegulatoryPermissionKeys] = useState<RequestRegulatoryPermissionKeys[]>([]);
  const [products, setProducts] = useState<Products[]>([]);
  const [availableEmails, setAvailableEmails] = useState<string[]>([]);

  const [isLoading, setIsLoading] = useState(true);
  const { client } = useClient();

  useEffect(() => {
    async function loadCatalogs() {
      try {
        const [
          activityTypesRes,
          installationKeysRes,
          permissionKeysRes,
          productsRes,
          emailsRes,
        ] = await Promise.all([
          getCompanyActivityTypes({ client }),
          getInstallationKeys({ client }),
          getRegulatoryPermissionKeys({ client }),
          getProducts({ client }),
          getEmailList({ client }),
        ]);

        setActivityTypes(activityTypesRes.data ?? []);
        setInstallationKeys(installationKeysRes.data ?? []);
        setRegulatoryPermissionKeys(permissionKeysRes.data ?? []);
        setProducts(productsRes.data ?? []);
        setAvailableEmails(emailsRes.data ?? []);
      } catch (error) {
        console.error("Error cargando catálogos:", error);
      } finally {
        setIsLoading(false);
      }
    }

    loadCatalogs();
  }, [client]);

  return {
    activityTypes,
    installationKeys,
    regulatoryPermissionKeys,
    products,
    availableEmails,
    isLoading,
  };
}